import r from "../_virtual/arbitrum.js";
import o from "../_virtual/arbitrumSepolia.js";
import f from "../_virtual/base.js";
import m from "../_virtual/baseSepolia.js";
import a from "../_virtual/bsc.js";
import t from "../_virtual/celo.js";
import e from "../_virtual/mainnet.js";
import i from "../_virtual/optimism.js";
import p from "../_virtual/optimismSepolia.js";
import d from "../_virtual/polygon.js";
import w from "../_virtual/sepolia.js";
const j = {
  1: e,
  10: i,
  56: a,
  137: d,
  8453: f,
  42161: r,
  42220: t,
  84532: m,
  421614: o,
  11155111: w,
  11155420: p
};
export {
  j as chainIcons
};
//# sourceMappingURL=icons.js.map
